import { isEmpty } from 'lodash';

import type { IQueryArgs } from '@/types/apiTypes';
import useQueryHelpers from '@/composables/useQueryHelpers';

const { deepUnref } = useQueryHelpers();

export { taskKeys } from '@satellite/composables/queryKeys';

export const authKeys = {
  all: ['auth'] as const,
  me: () => [...authKeys.all, 'me'] as const
};

export const warehouseKeys = {
  all: ['warehouses'] as const,
  list: (queryArgs?: IQueryArgs) => [...warehouseKeys.all, 'list', deepUnref(queryArgs)] as const
};

export const yardAssetKeys = (() => {
  const all = ['yard-assets'] as const;
  const assetContainers = {
    all: [...all, 'asset-containers'] as const,
    byWarehouse: (warehouseId: string | null | undefined, params?: unknown) =>
      [
        ...assetContainers.all,
        'by-warehouse',
        warehouseId,
        ...(isEmpty(params) ? [] : [deepUnref(params)])
      ] as const
  };
  const spots = {
    all: [...all, 'spots'] as const,
    byWarehouse: (warehouseId: string | null | undefined, params?: unknown, joins?: unknown) =>
      [
        ...spots.all,
        'by-warehouse',
        warehouseId,
        ...(isEmpty(params) ? [] : [deepUnref(params)]),
        ...(isEmpty(joins) ? [] : [deepUnref(joins)])
      ] as const
  };
  const spotAreas = {
    all: [...all, 'spot-areas'] as const,
    byWarehouse: (warehouseId: string | null | undefined, params?: unknown) =>
      [
        ...spotAreas.all,
        'by-warehouse',
        warehouseId,
        ...(isEmpty(params) ? [] : [deepUnref(params)])
      ] as const
  };
  const moveTasks = {
    all: [...all, 'move-tasks'] as const,
    active: (spotIds?: string[] | null) =>
      [...moveTasks.all, 'active', ...(isEmpty(spotIds) ? [] : [deepUnref(spotIds)])] as const
  };

  return {
    all,
    assetContainers,
    spots,
    spotAreas,
    moveTasks
  };
})();
